/* SneakBoutik : catalogue (filtres, tri, grille) et tuiles de l'accueil. Repris de la maquette. */
(() => {
'use strict';
const start = () => {
const {
  normalize, ALL_SIZES, sizeLabel, sizeValue, isPromo, discount, imgUrl, escapeHtml, titleCase, store, renderCard, readJson,
} = window.SBX;
const $ = (id) => document.getElementById(id);
const grid = $('grid');
const PRODUCTS = (readJson('sb-catalog') ?? []).map(normalize);
const BRANDS = [...new Set(PRODUCTS.map((p) => p.brand))].sort();
const PRICES = PRODUCTS.map((p) => p.price);
const PRICE_MIN = PRICES.length ? Math.floor(Math.min(...PRICES)) : 0;
const PRICE_MAX = PRICES.length ? Math.ceil(Math.max(...PRICES)) : 0;
const SORT_LABELS = { new: 'Nouveautés', discount: 'Meilleures réductions', asc: 'Prix croissant', desc: 'Prix décroissant' };
const bySizeOrder = (a, b) => sizeValue(a) - sizeValue(b);
const money = (n) => new Intl.NumberFormat(window.SBX.fmt.resolvedOptions().locale, { style: 'currency', currency: window.SBX.fmt.resolvedOptions().currency, maximumFractionDigits: 0 }).format(n);

const state = {
  sizes: new Set(store.get('size', [])),
  brands: new Set(),
  last: false,
  priceMax: PRICE_MAX,
  query: new URLSearchParams(location.search).get('q')?.trim().toLowerCase() ?? '',
  sort: 'new',
};

// ---------- Filtrage ----------
// `except` permet de calculer les compteurs d'un groupe sans s'auto-filtrer
function matches(p, except) {
  if (except !== 'size' && state.sizes.size && !p.sizes.some((s) => state.sizes.has(s))) return false;
  if (except !== 'brand' && state.brands.size && !state.brands.has(p.brand)) return false;
  if (state.last && (p.stock ?? p.sizes.length) !== 1) return false;
  if (p.price > state.priceMax) return false;
  if (state.query && !`${p.brand} ${p.name}`.toLowerCase().includes(state.query)) return false;
  return true;
}

const SORTS = {
  new: () => 0, // le serveur envoie déjà les paires de la plus récente à la plus ancienne
  discount: (a, b) => (isPromo(b) ? discount(b) : 0) - (isPromo(a) ? discount(a) : 0),
  asc: (a, b) => a.price - b.price,
  desc: (a, b) => b.price - a.price,
};

function results() {
  return PRODUCTS.filter((p) => matches(p))
    .sort(SORTS[state.sort])
    // Les paires épuisées restent visibles, en fin de liste
    .sort((a, b) => !a.sizes.length - !b.sizes.length);
}

const countBy = (except, key) => {
  const counts = new Map();
  PRODUCTS.filter((p) => p.sizes.length && matches(p, except))
    .forEach((p) => [].concat(key(p)).forEach((k) => counts.set(k, (counts.get(k) ?? 0) + 1)));
  return counts;
};

// ---------- Rendu ----------
// Au premier affichage sans filtre, les cartes rendues par le serveur (SEO) sont gardées telles quelles.
const isDefault = () => !state.sizes.size && !state.brands.size && !state.last && state.priceMax >= PRICE_MAX && !state.query && state.sort === 'new';
let keepServerCards = grid.hasAttribute('data-ssr');
function render() {
  const list = results();
  const available = list.filter((p) => p.sizes.length).length;
  if (keepServerCards && isDefault()) {
    window.SBX.syncWishButtons();
  } else {
    grid.replaceChildren(...list.map(renderCard));
    grid.removeAttribute('data-ssr');
  }
  keepServerCards = false;
  $('count').textContent = available.toLocaleString('fr-FR');
  document.querySelectorAll('[data-count]').forEach((el) => { el.textContent = available; });
  $('empty').hidden = list.length > 0;
  renderButtons();
  renderPanels();
  renderActive();
}

// Chaque bouton affiche sa sélection et passe en noir quand il est actif
function setButton(name, text, active) {
  const btn = document.querySelector(`[data-dd="${name}"] .dd__btn`);
  btn.querySelector('.dd__text').textContent = text;
  btn.classList.toggle('is-active', active);
}
function summary(label, values) {
  if (!values.length) return label;
  return `${label} · ${values[0]}${values.length > 1 ? ` +${values.length - 1}` : ''}`;
}

function renderButtons() {
  const sizes = [...state.sizes].sort(bySizeOrder).map(sizeLabel);
  setButton('size', sizes.length ? summary('Pointure', sizes) : 'Ma pointure', sizes.length > 0);
  setButton('brand', summary('Marque', [...state.brands].map(titleCase)), state.brands.size > 0);
  setButton('price', state.priceMax < PRICE_MAX ? `Prix · ≤ ${money(state.priceMax)}` : 'Prix', state.priceMax < PRICE_MAX);
  $('only-last').classList.toggle('is-active', state.last);
  $('only-last').setAttribute('aria-pressed', state.last);
  $('sort-label').textContent = SORT_LABELS[state.sort];

  // Mobile : pastille du nombre de filtres actifs et interrupteur « Dernières paires »
  const n = state.sizes.size + state.brands.size + (state.priceMax < PRICE_MAX) + state.last;
  $('mfilter-count').textContent = n;
  $('mfilter-count').hidden = !n;
  $('m-only-last').checked = state.last;
}

function renderPanels() {
  const bySize = countBy('size', (p) => p.sizes);
  $('size-grid').querySelectorAll('.size-btn').forEach((b) => {
    const n = bySize.get(b.dataset.size) ?? 0;
    const on = state.sizes.has(b.dataset.size);
    b.classList.toggle('is-active', on);
    b.setAttribute('aria-pressed', on);
    b.disabled = !n && !on;
    b.querySelector('small').textContent = n ? `${n} paire${n > 1 ? 's' : ''}` : '—';
  });

  const byBrand = countBy('brand', (p) => p.brand);
  const syncChecks = (list, set, counts) => list.querySelectorAll('input').forEach((i) => {
    const n = counts.get(i.value) ?? 0;
    i.checked = set.has(i.value);
    i.closest('label').classList.toggle('is-empty', !n && !i.checked);
    i.closest('label').querySelector('small').textContent = n;
  });
  syncChecks($('brand-list'), state.brands, byBrand);

  $('price').value = state.priceMax;
  $('price-value').textContent = state.priceMax >= PRICE_MAX ? 'Tous les prix' : money(state.priceMax);
  $('price').style.setProperty('--fill', `${((state.priceMax - PRICE_MIN) / (PRICE_MAX - PRICE_MIN)) * 100}%`);
  $('remember-size').checked = store.get('size', []).length > 0;
}

function renderActive() {
  const pills = [];
  const add = (label, clear) => pills.push({ label, clear });
  [...state.sizes].sort(bySizeOrder).forEach((s) => add(`Pointure ${sizeLabel(s)}`, () => state.sizes.delete(s)));
  state.brands.forEach((b) => add(titleCase(b), () => state.brands.delete(b)));
  if (state.priceMax < PRICE_MAX) add(`Jusqu'à ${money(state.priceMax)}`, () => { state.priceMax = PRICE_MAX; });
  if (state.last) add('Dernières paires', () => { state.last = false; });
  if (state.query) add(`« ${state.query} »`, () => { state.query = ''; $('search').value = ''; });

  const box = $('active-filters');
  box.hidden = !pills.length;
  box.replaceChildren(...pills.map(({ label, clear }) => {
    const b = document.createElement('button');
    b.className = 'pill';
    b.type = 'button';
    b.innerHTML = `${escapeHtml(label)}<svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><path d="M5 5l14 14M19 5 5 19"/></svg>`;
    b.setAttribute('aria-label', `Retirer le filtre ${label}`);
    b.addEventListener('click', () => { clear(); saveSize(); render(); });
    return b;
  }));
  if (pills.length > 1) {
    const reset = document.createElement('button');
    reset.className = 'pill pill--reset';
    reset.type = 'button';
    reset.textContent = 'Tout effacer';
    reset.addEventListener('click', resetAll);
    box.append(reset);
  }
}

function saveSize() {
  if ($('remember-size').checked) store.set('size', [...state.sizes]);
}

function resetAll() {
  Object.assign(state, { sizes: new Set(), brands: new Set(), last: false, priceMax: PRICE_MAX, query: '' });
  $('search').value = '';
  saveSize();
  render();
}

// ---------- Construction des menus ----------
const SIZES = [...new Set(PRODUCTS.flatMap((p) => p.sizes))].filter((x) => ALL_SIZES.includes(x)).sort(bySizeOrder);
$('size-grid').append(...SIZES.map((s) => {
  const b = document.createElement('button');
  b.type = 'button';
  b.className = 'size-btn';
  b.dataset.size = s;
  b.innerHTML = `<span>${sizeLabel(s)}</span><small></small>`;
  b.addEventListener('click', () => {
    state.sizes.has(s) ? state.sizes.delete(s) : state.sizes.add(s);
    saveSize();
    render();
  });
  return b;
}));

function checkList(list, values, set, label = (v) => v) {
  list.append(...values.map((v) => {
    const l = document.createElement('label');
    l.className = 'check';
    l.innerHTML = `<input type="checkbox" value="${v}"><span class="check__box"></span>${label(v)}<small></small>`;
    l.querySelector('input').addEventListener('change', (e) => {
      e.target.checked ? set.add(v) : set.delete(v);
      render();
    });
    return l;
  }));
}
checkList($('brand-list'), BRANDS, state.brands, titleCase);

Object.assign($('price'), { min: PRICE_MIN, max: PRICE_MAX });
$('price-min').textContent = money(PRICE_MIN);
$('price-max').textContent = money(PRICE_MAX);
$('price').addEventListener('input', (e) => { state.priceMax = +e.target.value; render(); });
$('remember-size').addEventListener('change', (e) => store.set('size', e.target.checked ? [...state.sizes] : []));
$('only-last').addEventListener('click', () => { state.last = !state.last; render(); });
$('sort-list').addEventListener('change', (e) => { state.sort = e.target.value; render(); closeMenus(); });
$('empty-reset').addEventListener('click', resetAll);

// Bouton « Effacer » propre à chaque menu
const CLEARS = {
  size: () => state.sizes.clear(),
  brand: () => state.brands.clear(),
  price: () => { state.priceMax = PRICE_MAX; },
};
document.querySelectorAll('[data-dd-clear]').forEach((b) => b.addEventListener('click', () => {
  CLEARS[b.closest('.dd').dataset.dd]();
  saveSize();
  render();
}));

// ---------- Ouverture / fermeture des menus (ordinateur) ----------
// Un seul menu ouvert à la fois ; clic à l'extérieur ou Échap pour fermer.
let openDd = null;
function closeMenus() {
  if (!openDd) return;
  openDd.querySelector('.dd__panel').hidden = true;
  openDd.querySelector('.dd__btn').setAttribute('aria-expanded', 'false');
  openDd.classList.remove('is-open');
  $('dd-overlay').hidden = true;
  openDd = null;
}
function openMenu(dd) {
  closeMenus();
  openDd = dd;
  dd.classList.add('is-open');
  const panel = dd.querySelector('.dd__panel');
  panel.hidden = false;
  dd.querySelector('.dd__btn').setAttribute('aria-expanded', 'true');
  $('dd-overlay').hidden = false;
  // Garde le menu dans l'écran s'il déborde à droite
  panel.classList.remove('is-flipped');
  if (panel.getBoundingClientRect().right > document.documentElement.clientWidth - 12) panel.classList.add('is-flipped');
}
document.querySelectorAll('.dd').forEach((dd) => {
  dd.querySelector('.dd__btn').addEventListener('click', () => (openDd === dd ? closeMenus() : openMenu(dd)));
});
document.querySelectorAll('[data-dd-close]').forEach((b) => b.addEventListener('click', closeMenus));
$('dd-overlay').addEventListener('click', closeMenus);
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  if (!$('msheet').hidden) return closeSheet();
  if (openDd) {
    const btn = openDd.querySelector('.dd__btn');
    closeMenus();
    btn.focus();
  }
});

// ---------- Mobile / tablette : panneau « Filtrer et trier » ----------
// Le contenu des menus (.dd__body) est déplacé dans le panneau à l'ouverture,
// puis remis dans son menu à la fermeture : un seul jeu de contrôles, toujours synchronisé.
const MOBILE = matchMedia('(max-width: 900px)');
const bodies = [...document.querySelectorAll('.dd__body')];
function openSheet() {
  closeMenus();
  bodies.forEach((b) => $('msheet').querySelector(`[data-slot="${b.dataset.body}"]`).append(b));
  $('msheet').hidden = false;
  document.body.classList.add('sheet-open');
  $('msheet-open').setAttribute('aria-expanded', 'true');
  $('msheet-close').focus({ preventScroll: true });
}
function closeSheet() {
  if ($('msheet').hidden) return;
  bodies.forEach((b) => document.querySelector(`[data-dd="${b.dataset.body}"] .dd__panel`).prepend(b));
  $('msheet').hidden = true;
  document.body.classList.remove('sheet-open');
  $('msheet-open').setAttribute('aria-expanded', 'false');
  $('msheet-open').focus({ preventScroll: true });
}
$('msheet-open').addEventListener('click', openSheet);
$('msheet-close').addEventListener('click', closeSheet);
$('msheet-apply').addEventListener('click', () => { closeSheet(); window.scrollTo({ top: 0, behavior: 'smooth' }); });
$('msheet-reset').addEventListener('click', resetAll);
$('m-only-last').addEventListener('change', (e) => { state.last = e.target.checked; render(); });
// Passage en grand écran panneau ouvert : on le referme
MOBILE.addEventListener('change', (e) => { if (!e.matches) closeSheet(); });

// ---------- Section d'accueil ----------
const promos = PRODUCTS.filter(isPromo);
document.querySelectorAll('[data-max-discount]').forEach((el) => {
  el.textContent = promos.length ? `-${Math.max(...promos.map(discount))}\u00a0%` : '';
});

// Tuiles : configurées dans la section d'accueil (marque ou « dernières paires »),
// chiffres tirés du stock ; photo choisie, ou première paire disponible si elle est vendue.
const inStock = PRODUCTS.filter((p) => p.sizes.length);
const TILE_CONFIG = readJson('sb-hero-tiles') ?? [];
const TILES = TILE_CONFIG.map((t) => {
  const isLast = t.filter === 'last';
  const brand = String(t.filter || '').toUpperCase();
  return {
    label: t.title,
    cover: t.cover,
    items: isLast ? inStock.filter((p) => (p.stock ?? p.sizes.length) === 1) : inStock.filter((p) => p.brand === brand),
    apply: isLast ? () => { state.last = true; } : () => { state.brands = new Set([brand]); },
  };
}).filter((t) => t.items.length);
$('hero-tiles')?.replaceChildren(...TILES.map((t) => {
  const li = document.createElement('li');
  const cover = t.items.find((p) => p.handle === t.cover) ?? t.items[0];
  li.innerHTML = `
    <a class="tile" href="#catalogue">
      <span class="tile__label"><b>${escapeHtml(t.label)}</b><span>${t.items.length} paire${t.items.length > 1 ? 's' : ''}</span></span>
      ${cover.images[0] ? `<img class="tile__img" src="${imgUrl(cover.images[0], 500)}" alt="" loading="lazy">` : ''}
      <span class="tile__cta">Voir <span aria-hidden="true">→</span></span>
    </a>`;
  li.querySelector('a').addEventListener('click', (e) => {
    e.preventDefault();
    Object.assign(state, { brands: new Set(), last: false });
    t.apply();
    render();
    $('catalogue').scrollIntoView({ behavior: 'smooth' });
  });
  return li;
}));

// ---------- Recherche ----------
$('search').value = state.query;
$('search').addEventListener('input', (e) => { state.query = e.target.value.trim().toLowerCase(); render(); });

render();
};
window.SBX ? start() : document.addEventListener('sb:ready', start, { once: true });
})();
